var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Lock_svg__a)",
  fill: "#191919"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.953 14.309a2.054 2.054 0 0 0 1.545 2.006v2.257h1.003v-2.257a2.05 2.05 0 1 0-2.548-2.006ZM10 13.269a1.048 1.048 0 1 1 .01 2.096 1.048 1.048 0 0 1-.01-2.097Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.352 8.257V6.62A6.376 6.376 0 0 0 4.053 4.14a6.375 6.375 0 0 0-.448 2.479v1.637H2v13.926h16V8.257h-1.648ZM4.608 6.62a5.372 5.372 0 1 1 10.741 0v1.637H4.61V6.62Zm12.389 14.56H3.003V9.26h13.994v11.92Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Lock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v22H0z"
})))));
export default SvgLock;